// extracted by mini-css-extract-plugin
export default {"delimiter":"AiPhotoGenerationToolbarDelimiter__delimiter--kH7ML"};